import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatArea, formatEOFound, ValidationStatusComponent } from 'utils/Helper';
import { Table, TableHeader, TableRow } from 'component/Table';
import { ReportActions } from '../ReportActions';
import { DAILY_HEADERS } from 'consts/ReportHeaders';
import { ReactComponent as SortByIcon } from 'assets/images/icons/Sort-by2.svg';
import { InteractiveValidationStatus } from 'component/InteractiveValidationStatus';
import CreateReportPopup from '../Components/CreateReportPopup';
import { toast } from 'react-toastify';

export const DailyTable = ({
  reports,
  setLoader,
  setReportsPageList,
  onLoadMore,
  hasMore,
  onSort,
  currentPage,
  onPageChange,
  onCreateReport
}) => {

  const handleStatusChange = (reportId, newStatus) => {
    setReportsPageList(prevList => ({
      ...prevList,
      results: prevList.results.map(item =>
        item.id === reportId
          ? {
              ...item,
              validation_status: newStatus,
              status_manually_changed: true
            }
          : item
      )
    }));
  };
  const [rotations, setRotations] = useState({});
  const [sortDirection, setSortDirection] = useState({});
  const [lastClickedIcon, setLastClickedIcon] = useState(null);

  const handleSortIconClick = async (key) => {
    try {
      setLoader(true);
      setReportsPageList([]);
      onPageChange(1);

      const currentDirection = sortDirection[key] || false;
      const newDirection = !currentDirection;
      setSortDirection(prev => ({
        ...prev,
        [key]: newDirection,
      }));

      const ordering = newDirection ? key : `-${key}`;
      await onSort(ordering);

      const currentRotation = rotations[key] || 0;
      const newRotation = currentRotation + 180;

      if (lastClickedIcon && lastClickedIcon !== key) {
        setRotations(prevRotations => ({
          ...prevRotations,
          [lastClickedIcon]: 0,
        }));
      }

      setRotations(prevRotations => ({
        ...prevRotations,
        [key]: newRotation,
      }));

      setLastClickedIcon(key);
    } catch (error) {
      console.error('Error during sorting:', error);
    } finally {
      setLoader(false);
    }
  };


  return (
    <div className="eore-table">
      <Table>
        <TableHeader>
          {DAILY_HEADERS?.map((header, index) => (
            <th
              key={index}
              className={`text-with-icon ${header.style ? '' : ''}`}
              style={header.style || {}}
            >
              {header.key && header.condition && (
                <SortByIcon
                  className="sort-icon"
                  style={{ transform: `rotate(${rotations[header.key] || 0}deg)` }}
                  onClick={() => handleSortIconClick(header.key)}
                />
              )}
              {header.label}
            </th>
          ))}
        </TableHeader>
        <tbody>
          {reports?.length === 0 && (
            <TableRow>
              <td>Дані відсутні</td>
            </TableRow>
          )}
          {reports?.map((item) => (
            <TableRow key={item?.id}>
              <td>{item?.created_at ? new Date(item?.created_at)?.toLocaleDateString('uk-UA', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }) : '-'}</td>
              <td>{item?.team_id || '-'}</td>
              <td>{item?.clearance_task_imsma_id || '-'}</td>
              <td>{item?.type || '-'}</td>
              <td>{formatArea(item?.area, item?.cleared_area)}</td>
              <td style={{ textAlign: 'start' }}>{formatEOFound(item?.eo_found)}</td>
              <td>
                <InteractiveValidationStatus
                  reportType="daily"
                  reportId={item?.id}
                  currentStatus={{
                    ...item?.validation_status,
                    status_manually_changed: item?.status_manually_changed
                  }}
                  onStatusChange={handleStatusChange}
                />
              </td>
              <td aria-label="actions">
                <ReportActions
                  reportId={item?.id}
                  clearanceId={item?.clearance_task_id}
                  setLoader={setLoader}
                  setReportsPageList={setReportsPageList}
                  validationStatus={item?.validation_status?.value}
                  isCurrentValidationRole={item?.is_current_validation_role}
                  mode="daily"
                />
              </td>
            </TableRow>
          ))}
          {hasMore && (
            <div className="loadMore-div">
              <button
                className="loadMore-button"
                onClick={onLoadMore}
              >
                Load more...
              </button>
            </div>
          )}
          <div className="drone-footer">
            <CreateReportPopup
              type="daily"
              onCreateReport={onCreateReport}
              menuPortalTarget={document?.body}
              customStyles={{
                menu: (provided) => ({
                  ...provided,
                  position: 'absolute',
                  zIndex: 9999,
                  width: '100%',
                  top: '100%',
                  left: 0
                }),
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999
                }),
                control: (provided) => ({
                  ...provided,
                  position: 'relative'
                }),
                container: (provided) => ({
                  ...provided,
                  position: 'relative'
                })
              }}
            />
          </div>
        </tbody>
      </Table>
    </div>
  );
};

const DailyTab = ({
  setLoader,
  dailyList,
  setDailyList,
  currentPage,
  onPageChange,
  onFetch
}) => {
  const [sortParams, setSortParams] = useState('');
  const navigate = useNavigate();

  const handleSort = (ordering) => {
    onPageChange(1);
    setSortParams(ordering);
    setLoader(true);
    return onFetch(1, ordering)
      .finally(() => {
        setLoader(false);
      });
  };

  const handleLoadMore = () => {
    const nextPage = currentPage + 1;
    onPageChange(nextPage);
    setLoader(true);
    onFetch(nextPage, sortParams)
    .finally(() => {
      setLoader(false);
    });
  };

      const handleCreateDaily = (reportData) => {
    sessionStorage.setItem('createDailyData', JSON.stringify({
      type: reportData.type,
      subType: reportData.subType,
      hideNavigation: true
    }));


    if (!reportData?.type) {
      toast.error('Please select report type');
      return false;
    }

    if (reportData?.type === 'Empty') {
      navigate(`/task-clearance/empty/daily/create`);
      return true;
    }

    if (!reportData?.subType) {
      toast.error('Please select TCP IMSMA ID');
      return false;
    }


    const clearanceId = reportData?.subType;

    navigate(`/task-clearance/${clearanceId}/daily/create`);
    return true;
  };

    return (
    <DailyTable
      reports={dailyList?.results || []}
      hasMore={!!dailyList?.next}
      onLoadMore={handleLoadMore}
      setLoader={setLoader}
      setReportsPageList={setDailyList}
      onSort={handleSort}
      currentPage={currentPage}
      onPageChange={onPageChange}
      onCreateReport={handleCreateDaily}
    />
  );
};

export default DailyTab;